<template>
  <div class="header-image">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: ['src']
  }
</script>

<style lang="scss" scoped>
  .header-image img {
    display: block;
  }
</style>